/** A value the participant app puts in at runtime: `{{time}}`. */
export const RUNTIME_VALUE = /\{\{\s*([^{}\s]+)\s*\}\}/g;
/** A value Clair fills in before the text is shown: `{company}`, never `{{company}}`. */
export const FILLED_VALUE = /(?<!\{)\{\s*([^{}\s]+)\s*\}(?!\})/g;
//# sourceMappingURL=placeholderPatterns.js.map